// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__12s7c","productName":"Table_productName__31l9Y"};